import {Parent} from "common/models";
import {RootState} from "core/store/store";
import {useSelector} from "react-redux";

export function useParent(): Parent {
  return useSelector((state: RootState) => state.parentStore.parent!);
}
